var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.24H18.6925V16.4544H0V18.24ZM6.54238 11.9904V9.58872L14.5558 2.41236L16.2672 4.23457L8.93969 11.9904H6.54238ZM19 4.23636L14.6073 0L4.67313 8.83519V13.776H9.73972L19 4.23636Z",
    fill: "#3D3C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChange);
export default __webpack_public_path__ + "static/media/ic_change.718f1c716c63e1ec4051e284e4768dbf.svg";
export { ForwardRef as ReactComponent };